import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LessonType} from "../../components/teacher-lessons/teacher-lessons.component";
import {Page, Pageable} from "../../model/rest/base";
import * as LessonsV3 from "../../model/v3/lessons";

@Component({
    selector: 'app-manager-teacher-lessons-page',
    templateUrl: './manager-teacher-lessons-page.component.html',
    styleUrls: ['./manager-teacher-lessons-page.component.css'],
    standalone: false
})
export class ManagerTeacherLessonsPageComponent implements OnInit {

  schoolId: string;
  teacherId: string;
  lessonTypes = LessonType;
  futureData: Page<LessonsV3.LFTeacherGeneral>;
  futurePageable: Pageable;
  incompleteData: Page<LessonsV3.LFTeacherGeneral>;
  incompletePageable: Pageable;
  pastData: Page<LessonsV3.LFTeacherGeneral>;
  pastPageable: Pageable;

  constructor(activatedRoute: ActivatedRoute) {
    activatedRoute.parent.paramMap.subscribe( params => {
      this.schoolId = params.get('schoolId');
      this.teacherId = params.get('teacherId');
    });
  }

  ngOnInit() {
  }

}
